import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = { projectId: String }

  async addScene(event) {
    event.preventDefault()

    const container = this.element.querySelector('#scene_forms_container')
    const sceneForms = container.querySelectorAll('.scene-form')
    const lastSceneForm = sceneForms[sceneForms.length - 1]
    let nextSequence = 0
    if (lastSceneForm) {
      const lastSeqNumInput = lastSceneForm.querySelector(
        "input[name='scene[sequence]']"
      )
      if (lastSeqNumInput) {
        nextSequence = parseInt(lastSeqNumInput.value, 10) + 1
      }
    }

    const url = `/ai-cg/projects/${this.projectIdValue}/scenes/add_scene?sequence=${nextSequence}`
    await get(url, { responseKind: 'turbo-stream' })
  }

  removeScene(event) {
    const sceneRow = event.target.closest('.scene-row')
    if (sceneRow) {
      sceneRow.remove()
    }
  }
}
